import axios from "axios";
import store from "@/store/index";
import apiErrors from "@/plugins/api/apiErrorHandler";
import router from "@/router";

let numberOfAjaxCAllPending = 0;

axios.interceptors.request.use(
  function (config) {
    numberOfAjaxCAllPending++;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    numberOfAjaxCAllPending--;
    return response;
  },
  function (error) {
    numberOfAjaxCAllPending--;
    return Promise.reject(error);
  }
);

// 🔑 функция для выбора baseURL
function getBaseUrl(useNew = false) {
  return useNew
    ? process.env.VUE_APP_NEW_API_URL
    : process.env.VUE_APP_API_ENDPOINT_URL;
}

const api = {
  getHeaders(file = false) {
    store.commit("Api/SET_UPLOADING_PROGRESS", 0);
    let requestHeader = {
      timeout: process.env.VUE_APP_AXIOS_TIMEOUT,
      headers: {
        "Content-Type": file ? "multipart/form-data" : "application/json",
        "Accept-Language": store.state.Auth.locale,
      },
    };

    if (file) {
      requestHeader.onUploadProgress = (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        store.commit("Api/SET_UPLOADING_PROGRESS", percentCompleted);
      };
    }
    // ✅ Этот блок правильно добавляет токен в заголовок для всех запросов
    if (store.state.Auth.authToken !== null) {
      requestHeader.headers[
        "Authorization"
      ] = `Bearer ${store.state.Auth.authToken}`;
    }
    return requestHeader;
  },

  async handleUnknownError(error) {
    throw new Error(error);
  },

  async handleTokenRefresh(res, callBackFn) {
    if (Object.keys(res).indexOf("message") >= 0) {
      if (res.message === "Token has expired") {
        await store.dispatch("Auth/refreshToken");
        callBackFn();
      }
    }
  },

  async delete(path, cb = null, useNew = false) {
    store.commit("Api/showLoader");
    return axios
      .delete(getBaseUrl(useNew) + path, this.getHeaders())
      .then((response) => {
        store.commit("Api/resetTries");
        if (cb !== null) {
          return cb(response.data);
        } else {
          return response;
        }
      })
      .catch(async (error) => {
        console.log("ERROR DELETE ERROR PATH: " + path);
        const errorType = apiErrors.getTypeOfError(error);
        switch (errorType) {
          case process.env.VUE_APP_RETRY_STATUS:
            if (store.state.Api.tries < process.env.VUE_APP_RETRY_COUNT) {
              store.commit("Api/setRetry");
              return await this.get(path, cb, useNew);
            }
            break;
          case process.env.VUE_APP_REDIRECT_STATUS:
            if (
              store.state.BackButton.currentRoute !==
              process.env.VUE_APP_REDIRECT_ON_ERROR_TO
            ) {
              if (
                router.currentRoute.name !==
                process.env.VUE_APP_REDIRECT_ON_ERROR_TO
              ) {
                await router.push({
                  name: process.env.VUE_APP_REDIRECT_ON_ERROR_TO,
                });
              }
            }
            break;
          case process.env.VUE_APP_REFRESH_TOKEN:
            await store.dispatch("Auth/refreshToken");
            await this.delete(path, cb, useNew);
            break;
          default:
            await this.handleUnknownError(error);
        }
        return false;
      })
      .finally(() => {
        if (numberOfAjaxCAllPending === 0) {
          store.commit("Api/hideLoader");
        }
        return true;
      });
  },

  post(path, data, cb = null, file = false, useNew = false) {
    store.commit("Api/resetValidationErrors");
    store.commit("Api/showLoader");

    let requestData = data;
    if (
      path === "bills" &&
      (!requestData || Object.keys(requestData).length === 0)
    ) {
      requestData = { token: store.state.Auth.authToken };
    }

    return axios
      .post(getBaseUrl(useNew) + path, requestData, this.getHeaders(file))
      .then((response) => {
        store.commit("Api/resetTries");
        store.commit("Api/resetValidationErrors");
        if (cb !== null) {
          return cb(response.data);
        } else {
          return response;
        }
      })
      .catch(async (error) => {
        console.log("ERROR POST ERROR PATH: " + path);
        const errorType = apiErrors.getTypeOfError(error);
        switch (errorType) {
          case process.env.VUE_APP_RETRY_STATUS:
            if (store.state.Api.tries < process.env.VUE_APP_RETRY_COUNT) {
              store.commit("Api/setRetry");
              return await this.post(path, data, cb, file, useNew);
            }
            break;
          case process.env.VUE_APP_REDIRECT_STATUS:
            if (
              store.state.BackButton.currentRoute !==
              process.env.VUE_APP_REDIRECT_ON_ERROR_TO
            ) {
              if (
                router.currentRoute.name !==
                process.env.VUE_APP_REDIRECT_ON_ERROR_TO
              ) {
                await router.push({
                  name: process.env.VUE_APP_REDIRECT_ON_ERROR_TO,
                });
              }
            }
            break;
          case process.env.VUE_APP_VALIDATION_ERROR_STATUS:
            store.commit("Api/setValidationErrors", error.response.data);
            break;
          case process.env.VUE_APP_REFRESH_TOKEN:
            await store.dispatch("Auth/refreshToken");
            await this.post(path, data, cb, file, useNew);
            break;
          case process.env.VUE_APP_ERROR_STATUS:
            break;
          default:
            // Ничего не делаем, просто пробрасываем ошибку
            break;
        }
        return Promise.reject(error); // ПРОБРАСЫВАЕМ ОШИБКУ ДАЛЬШЕ
      })
      .finally(() => {
        if (numberOfAjaxCAllPending === 0) {
          store.commit("Api/hideLoader");
        }
      });
  },

  put(path, data, cb = null, useNew = false) {
    store.commit("Api/resetValidationErrors");
    store.commit("Api/showLoader");
    return axios
      .put(getBaseUrl(useNew) + path, data, this.getHeaders())
      .then((response) => {
        store.commit("Api/resetTries");
        store.commit("Api/resetValidationErrors");
        if (cb !== null) {
          return cb(response.data);
        } else {
          return response;
        }
      })
      .catch(async (error) => {
        console.log("ERROR PUT ERROR PATH: " + path);
        const errorType = apiErrors.getTypeOfError(error);
        switch (errorType) {
          case process.env.VUE_APP_RETRY_STATUS:
            if (store.state.Api.tries < process.env.VUE_APP_RETRY_COUNT) {
              store.commit("Api/setRetry");
              return await this.post(path, data, cb, useNew);
            }
            break;
          case process.env.VUE_APP_REDIRECT_STATUS:
            if (
              store.state.BackButton.currentRoute !==
              process.env.VUE_APP_REDIRECT_ON_ERROR_TO
            ) {
              if (
                router.currentRoute.name !==
                process.env.VUE_APP_REDIRECT_ON_ERROR_TO
              ) {
                await router.push({
                  name: process.env.VUE_APP_REDIRECT_ON_ERROR_TO,
                });
              }
            }
            break;
          case process.env.VUE_APP_VALIDATION_ERROR_STATUS:
            store.commit("Api/setValidationErrors", error.response.data);
            break;
          case process.env.VUE_APP_REFRESH_TOKEN:
            await store.dispatch("Auth/refreshToken");
            await this.put(path, data, cb, useNew);
            break;
          case process.env.VUE_APP_ERROR_STATUS:
            break;
          default:
            await this.handleUnknownError(error);
        }
        return false;
      })
      .finally(() => {
        if (numberOfAjaxCAllPending === 0) {
          store.commit("Api/hideLoader");
        }
      });
  },

  async get(path, cb = null, useNew = false) {
    store.commit("Api/showLoader");
    return axios
      .get(getBaseUrl(useNew) + path, this.getHeaders())
      .then((response) => {
        store.commit("Api/resetTries");
        if (cb !== null) {
          return cb(response.data);
        } else {
          return response;
        }
      })
      .catch(async (error) => {
        console.log("ERROR GET ERROR PATH: " + path);
        const errorType = apiErrors.getTypeOfError(error);
        switch (errorType) {
          case process.env.VUE_APP_RETRY_STATUS:
            if (store.state.Api.tries < process.env.VUE_APP_RETRY_COUNT) {
              store.commit("Api/setRetry");
              return await this.get(path, cb, useNew);
            }
            break;
          case process.env.VUE_APP_REDIRECT_STATUS:
            if (
              store.state.BackButton.currentRoute !==
              process.env.VUE_APP_REDIRECT_ON_ERROR_TO
            ) {
              if (
                router.currentRoute.name !==
                process.env.VUE_APP_REDIRECT_ON_ERROR_TO
              ) {
                await router.push({
                  name: process.env.VUE_APP_REDIRECT_ON_ERROR_TO,
                });
              }
            }
            break;
          case process.env.VUE_APP_REFRESH_TOKEN:
            await store.dispatch("Auth/refreshToken");
            await this.get(path, cb, useNew);
            break;
          default:
            await this.handleUnknownError(error);
        }
        return false;
      })
      .finally(() => {
        if (numberOfAjaxCAllPending === 0) {
          store.commit("Api/hideLoader");
        }
        return true;
      });
  },
};

export default api;
